@if (banner) {
  @if (banner.url) {
    <a
      target="_blank"
      href="{{ banner.url }}{{ utm(banner.url) }}"
      [id]="bannerPositionId + ' | ' + banner.url"
      class="app-banner-main"
      (click)="click()"
      >
      <img
        src="{{ banner.path }}"
        class="banner"
        fetchpriority="high"
        alt="{{ banner.altText }}"
        style="width: 100%"
            srcset="{{ banner.small_image }} 600w,
            {{ banner.medium_image }} 1024w,
            {{ banner.large_image }} 1600w"
        />
    </a>
  } @else {
    @if (!banner.url) {
      <img
        src="{{ banner.path }}"
        class="banner"
        fetchpriority="high"
        alt="{{ banner.altText }}"
        style="width: 100%"
            srcset="{{ banner.small_image }} 600w,
            {{ banner.medium_image }} 1024w,
            {{ banner.large_image }} 1600w"
        />
    }
  }
}
